module.exports = __webpack_public_path__ + "img/wallet.847a4488.png";